import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-20 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-4xl">
        <Button 
          onClick={() => navigate('/')} 
          variant="outline"
          className="mb-8 border-orange-500 text-orange-500 hover:bg-orange-50"
        >
          <ArrowLeft size={18} className="mr-2" />
          Zurück zur Startseite
        </Button>

        <Card className="shadow-xl">
          <CardHeader className="border-b border-gray-200">
            <CardTitle className="text-3xl font-bold text-gray-900">
              Impressum
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-8 space-y-6 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Angaben gemäß § 5 TMG</h2>
              <p>
                <strong>AppPilot</strong><br />
                Eugen Limon<br />
                Hölzlestraße 27<br />
                78315 Radolfzell am Bodensee<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Vertreten durch</h2>
              <p>
                Eugen Limon (Inhaber)
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Kontakt</h2>
              <p>
                <strong>E-Mail:</strong> info@apppilot.de<br />
                <strong>Telefon:</strong> +49 (0) 172 77 85 888<br />
                <strong>Website:</strong> www.apppilot.de
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Umsatzsteuer-ID</h2>
              <p>
                Als Kleinunternehmer im Sinne von § 19 Abs. 1 UStG wird keine Umsatzsteuer berechnet.<br />
                Daher erfolgt keine Angabe einer Umsatzsteuer-Identifikationsnummer.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p>
                Eugen Limon<br />
                Hölzlestraße 27<br />
                78315 Radolfzell am Bodensee
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">EU-Streitschlichtung</h2>
              <p className="mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600 underline">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Haftungsausschluss</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">Haftung für Inhalte</h3>
              <p className="mb-4">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
                Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                nach den allgemeinen Gesetzen verantwortlich.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">Haftung für Links</h3>
              <p className="mb-4">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                Seiten verantwortlich.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">Urheberrecht</h3>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung 
                des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Impressum;